import { TimeStore } from './timeTypes'
import { TimeActionTypes, TimeActions } from './timeActions'

export const initialState: TimeStore = {
  server: '',
  client: ''
}

export function timeReducer(state: TimeStore = initialState, action: TimeActions): TimeStore {
  return action.type === TimeActionTypes.SET_TIMES
    ? {
        ...state,
        server: action.payload.server,
        client: action.payload.client
      }
    : state
}
